import ProfileComponent from "../components/Auth/ProfileComponent";

export default function ProfilePage(){


    return <ProfileComponent/>
}